export default __webpack_public_path__ + "static/media/mozilla-logo-bw-rgb.b2e6c064.png";